module.exports = __webpack_public_path__ + "img/employee.46448f09.png";